import React from 'react'

export default function Report() {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <path id="Report" d="M26,9.333V9.056A3.059,3.059,0,0,0,22.944,6H9.056A3.059,3.059,0,0,0,6,9.056v.278ZM6,11V22.944A3.055,3.055,0,0,0,9.056,26H22.944A3.055,3.055,0,0,0,26,22.944V11Zm4.722,12.222a1.389,1.389,0,1,1,1.389-1.389A1.389,1.389,0,0,1,10.722,23.222Zm0-3.889a1.389,1.389,0,1,1,1.389-1.389A1.389,1.389,0,0,1,10.722,19.333Zm11.111,3.333H14.611a.833.833,0,1,1,0-1.667h7.222a.833.833,0,1,1,0,1.667Zm0-3.889H14.611a.833.833,0,1,1,0-1.667h7.222a.833.833,0,1,1,0,1.667Zm0-3.889H10.167a.833.833,0,0,1,0-1.667H21.833a.833.833,0,1,1,0,1.667Z" transform="translate(-6 -6)" fill="#fff"/>
</svg>

  )
}